module.exports = __webpack_public_path__ + "img/nbs.878d3746.png";